// Convert markdown to plain text for schema.org description fields and other
// places where we need a clean readable string out of editor-formatted copy.
// Removes ## headers, **bold**, _italic_, [link](url), - lists, code spans.
export function stripMarkdown(md: string): string {
  if (!md) return '';
  return md
    .replace(/^#{1,6}\s+/gm, '')                  // # H1, ## H2, ...
    .replace(/\*\*(.+?)\*\*/g, '$1')              // **bold**
    .replace(/__(.+?)__/g, '$1')                  // __bold__
    .replace(/(?<!\*)\*([^*]+)\*(?!\*)/g, '$1')   // *italic*
    .replace(/(?<!_)_([^_]+)_(?!_)/g, '$1')       // _italic_
    .replace(/\[(.+?)\]\(.+?\)/g, '$1')           // [text](url) → text
    .replace(/`([^`]+)`/g, '$1')                  // `code`
    .replace(/^\s*[-*+]\s+/gm, '')                // - list items
    .replace(/^\s*\d+\.\s+/gm, '')                // 1. list items
    .replace(/\n{2,}/g, ' ')                      // collapse paragraph breaks
    .replace(/\s+/g, ' ')                         // normalize whitespace
    .trim();
}
